import { ProductPaymentType } from '../enums/product-payment.enum';
import { KioskCarDetailsModel } from './kiosk-get-reservation-response.model';

export interface IKioskCarsAvailabilityModel {
  extraPricePerDay: number;
  rentalPrice: number;
  airPortFee: number;
  deductibleAmount: number;
  carDetails: KioskCarDetailsModel;
  products: KioskProductModel[];
  canEditProducts: boolean;
  includedVat: boolean;
  currency: string;
  id: string;
}

export class KioskCarsAvailabilityModel implements IKioskCarsAvailabilityModel {
  extraPricePerDay: number;
  rentalPrice: number;
  airPortFee: number;
  deductibleAmount: number;
  carDetails: KioskCarDetailsModel;
  products: KioskProductModel[];
  canEditProducts: boolean;
  includedVat: boolean;
  currency: string;
  id: string;

  constructor() {
    this.products = [];
    this.airPortFee = 0;
    this.deductibleAmount = 0;
    this.rentalPrice = 0;
    this.extraPricePerDay = 0;
    this.carDetails = new KioskCarDetailsModel();
    this.canEditProducts = true;
    this.includedVat = true;
    this.currency = '';
    this.id = '';
  }
}

export interface IKioskProductModel {
  id: string;
  name: string;
  description: string;
  currencyCode: string;
  price: number;
  paymentType: ProductPaymentType;
  count: number;
  maxPrice: number | null;
  isIncluded: boolean;
  isRequired: boolean;
  isInsurance: boolean;
  isBaseInsurance: boolean;
  maxAllowedItems: number;
}

export class KioskProductModel implements IKioskProductModel {
  id: string;
  name: string;
  description: string;
  currencyCode: string;
  price: number;
  paymentType: ProductPaymentType;
  count: number;
  maxPrice: number | null;
  isIncluded: boolean;
  isRequired: boolean;
  isInsurance: boolean;
  isBaseInsurance: boolean;
  maxAllowedItems: number;

  constructor() {
    this.count = 0;
    this.maxPrice = 0;
    this.maxAllowedItems = 0;
    this.price = 0;
    this.currencyCode = '';
    this.id = '';
    this.name = '';
    this.description = '';
    this.paymentType = ProductPaymentType.Daily;
    this.isIncluded = true;
    this.isRequired = true;
    this.isInsurance = true;
    this.isBaseInsurance = true;
  }
}
